import styled from 'styled-components';
import { WebLink } from 'ui/theme';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { useTemplateContext } from '../../../context';
import { EmbeddedPrimaryContent } from '../../../types';

import { CommaSeparatedList, CommaSeparatedListItem, LightText } from '../Sections.styled';
import { RawJsonViewer } from './RawJsonViewer';

const OpenActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const defaultActionMapper: Record<string, string> = {
  openUrl: 'Open URL',
};

export const EmbeddedBehavior = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;
  const { elements, payload } = primaryContent as EmbeddedPrimaryContent;
  const defaultAction = elements?.defaultAction;
  const actionButtons = elements?.buttons;

  return (
    <>
      <CampaignFormField labelText="Open action">
        <ReadOnlyField name="defaultAction">
          {defaultAction ? (
            <OpenActionWrapper>
              <span>{defaultActionMapper?.[defaultAction?.type] || 'Custom action'}</span>
              {defaultAction?.data && (
                <WebLink href={defaultAction?.data}>{defaultAction?.data}</WebLink>
              )}
            </OpenActionWrapper>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Action buttons">
        <ReadOnlyField name="actionButtons">
          {actionButtons?.length ? (
            <CommaSeparatedList>
              {actionButtons?.map((actionButton, index) => (
                <CommaSeparatedListItem key={index}>
                  {actionButton?.title || ''}
                </CommaSeparatedListItem>
              ))}
            </CommaSeparatedList>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
      <RawJsonViewer payload={payload} />
    </>
  );
};
